export const ApiEntitySurcharges = (axios, obuBaseUrl) => {
  axios.setBaseURL(obuBaseUrl)

  const load = async (id, module = 'accommodations') => {
    const result = await axios.get(`/api/entities/${module}/${id}/surcharges`)
    return result.data
  }

  const remove = async (id, sid, payload, module = 'accommodations') => {
    const result = await axios.delete(`/api/entities/${module}/${id}/surcharges/${sid}`)
    return result.data
  }

  const save = async (id, payload, module = 'accommodations') => {
    const result = await axios.post(`/api/entities/${module}/${id}/surcharges/${payload.surcharge.id}`, payload)
    return result.data
  }

  const check = async (id, payload, module = 'accommodations') => {
    const result = await axios.post(`/api/entities/${module}/${id}/surcharges/check`, payload)
    console.log(result.data)
    return result.data
  }

  return {
    entitySurchargesCheck: check,
    entitySurchargesLoad: load,
    entitySurchargesRemove: remove,
    entitySurchargesSave: save
  }
}
